import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { IntlService } from 'ember-intl';
import type { LinkManagerService } from 'ember-link';
import type { ShipmentTypeFilter } from 'graphql-models';

export default class AppShipmentsFiltersController extends Controller {
  @service('intl') declare intlService: IntlService;
  @service('link-manager') declare linkManagerService: LinkManagerService;

  @tracked shipmentType: ShipmentTypeFilter = 'ALL' as ShipmentTypeFilter;
  @tracked fromDate: string | undefined;
  @tracked toDate: string | undefined;

  queryParams = ['shipmentType', 'fromDate', 'toDate'];

  get shipmentListWithFiltersLink() {
    return this.linkManagerService.createLink({
      route: 'app.shipments',
      query: {
        shipmentType: this.shipmentType,
        fromDate: this.fromDate,
        toDate: this.toDate,
      },
    });
  }
  get shipmentListWithNoFiltersLink() {
    return this.linkManagerService.createLink({
      route: 'app.shipments',
      // explicitly setting these to undefined because otherwise the Ember route remembers the query params which were originally on the app.shipments route
      query: {
        shipmentType: undefined,
        fromDate: undefined,
        toDate: undefined,
      },
    });
  }

  get shipmentTypeOptions() {
    return [
      {
        label: this.intlService.t('pages.shipments.filters.shipmentType.optionAll'),
        value: 'ALL',
      },
      {
        label: this.intlService.t('pages.shipments.filters.shipmentType.optionBox'),
        value: 'BOX',
      },
    ];
  }
}
